import { observer } from 'mobx-react';
import { useEffect } from 'react';

import type ClientStore from 'stores/Client';
import store from 'stores/RootStore';

import AddProjectButton from '../../UI/AddDocument/AddProjectButton';
import DocumentFolderView from '../../UI/DocumentFolderView/DocumentFolderView';

const CLIENT_VIEW_TITLE = 'Client';

interface ClientContentProps {
  client?: ClientStore | undefined;
  documentTitle?: string;
}

function ClientContent({ client, documentTitle }: ClientContentProps) {
  useEffect(() => {
    document.title = documentTitle || CLIENT_VIEW_TITLE;
  }, [documentTitle]);

  return (
    <DocumentFolderView
      childrenTableTitle="Projects"
      parentDocument={client}
      childrenTableHeaderButtons={
        client && <AddProjectButton parentDocument={client} />
      }
    />
  );
}

function Client() {
  return (
    <ClientContent
      client={store.client}
      documentTitle={store.current?.data?.name}
    />
  );
}

export default observer(Client);
